module.exports = __webpack_public_path__ + "img/3.55a7807e.jpeg";